import { createSlice } from '@reduxjs/toolkit';

const initialGroupState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  entitiesPreview: null,
  groupForEdit: undefined,
  lastError: null,
  questionUnread: 0
};
export const callTypes = {
  list: 'list',
  action: 'action'
};

export const groupSlice = createSlice({
  name: 'Group',
  initialState: initialGroupState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    endCall: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.listLoading = false;
    },
    // get group ById
    groupFetched: (state, action) => {
      state.actionsLoading = false;
      state.groupForEdit = action.payload.groupForEdit;
      state.error = null;
      state.actionsLoading = false;
    },
    // find group
    groupsFetched: (state, action) => {
      const entities = action.payload.userQuestions;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = action.payload.total;
      state.actionsLoading = false;
    },

    groupsUnreadFetched: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.questionUnread = action.payload.total;
      state.actionsLoading = false;
    },
    //
    groupsPreviewFetched: (state, action) => {
      const { entities } = action.payload;
      state.listLoading = false;
      state.actionsLoading = false;
      state.error = null;
      state.entitiesPreview = entities;
    },
    // create group
    groupCreated: (state, action) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.group);
    },
    // update group
    groupUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.id === action.payload.group.id) {
          return action.payload.group;
        }
        return entity;
      });
    },
    // delete group
    groupDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.id !== action.payload.id);
    },
    // delete group
    groupsDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => !action.payload.ids.includes(el.id));
    },
    // groupUpdateState
    groupStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map(entity => {
        if (ids.findIndex(id => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    }
  }
});
